import React from 'react';
import { buildStripeCustomerUrl } from '../../../config/api';

export interface StripeCustomerLinkProps {
  stripeCustomerId: string | null;
}

/** Renders a deep link to the company's Stripe customer record, only when one exists. */
export function StripeCustomerLink({ stripeCustomerId }: StripeCustomerLinkProps): React.ReactElement | null {
  if (!stripeCustomerId) {
    return null;
  }
  return (
    <a
      className="bo-btn bo-btn-secondary"
      href={buildStripeCustomerUrl(stripeCustomerId)}
      target="_blank"
      rel="noopener noreferrer"
    >
      View in Stripe
    </a>
  );
}
